module.exports = __webpack_public_path__ + "img/sys.2d64b25d.svg";